var Vue = require('vue');
var axios = require('axios');
var VueAxios = require('vue-axios');
var sw  = require('js/lib/sw');
var _ = require('underscore');
Vue.use(VueAxios, axios);

function initialDataState() {
    return {
        user: sw.data.user,
        vatNumbers: sw.data.vatNumbers,
        countries: sw.data.countries,
        usaCountryCode: 'US',
        emailFromShopOwnerSettingId : 13,
        emailPreferences: sw.data.emailPreferences,
        userTypes: sw.data.userTypes,
        addNewVat: false,
        newVatData: {
            businessName: '',
            countryCode: null,
            stateProvinceAbbreviation: '',
            stateProvinceId: 0,
            chamberOfCommerce: '',
            vat: '',
            isValid: true,
            userId: sw.data.user.userId,
            validate: true
        }
    }
};

module.exports = function ($fragment) {
    $fragment.swFindWithSelf("[data-sw-edit-user]").each(function () {
        new Vue({
            el: this,
            data: initialDataState(),
            methods: {
                packageData: function(data) {
                    var form = new FormData();
                    for ( const key in data ) {
                        form.append(key, data[key]);
                    }
                    return form
                },
                saveUser: function() {
                    var self = this;
                    self.user.emailPreferences = JSON.stringify(self.emailPreferences);
                    var formData = self.packageData(self.user);
                    axios.post("/cs-portal/save-edit-user", formData)
                        .then(function (response) {
                           window.location.href = "/cs-portal/view-user?userId=" + self.user.userId;
                        })
                        .catch(function (error) {
                            sw.notifications.error("Something went wrong. User was not saved");
                        })
                },
                saveVat: function() {
                    var self = this;
                    formData = self.packageData(self.newVatData);
                    axios.post("/cs-portal/vat-numbers/save", formData)
                        .then(function (response) {
                            if(self.newVatData.stateProvinceId !== 0) {
                                var stateProvinceId = self.newVatData.stateProvinceId;
                                var stateSelected = _.find(self.countries.usStates, function(state) {
                                    return state.stateProvinceId === stateProvinceId;
                                });
                                self.newVatData.stateProvinceAbbreviation = stateSelected.stateProvinceAbbreviation;
                            }
                            self.vatNumbers.push(self.newVatData);
                            self.addNewVat = false;
                            self.newVatData = initialDataState().newVatData;
                            sw.notifications.success("VAT number saved!");
                        })
                        .catch(function (error) {
                            sw.notifications.error("Failed to save VAT Number: " + error.response.data.error);
                        })
                },
                checkVat: function(vatNumber) {
                    axios.get("/cs-portal/vat-numbers/check?vat_number_id=" + vatNumber)
                        .then(function(response) {
                            if(response.data.valid === true) {
                                sw.notifications.success("Valid!");
                            } else {
                                sw.notifications.error("Invalid!");
                            }
                        })
                },
                rejectVat: function(vatNumber) {
                    var data = this.packageData({vat_number_id: vatNumber, reject: true});
                    axios.post('/cs-portal/vat-numbers/update', data)
                        .then(function (response) {
                            if (response.data.success) {
                                sw.notifications.success("VAT Number Rejected!");
                            } else {
                                sw.notifications.error("Something went wrong. VAT Number not rejected!");
                            }
                        })
                        .catch(function (error) {
                            sw.notifications.error("Something went wrong. VAT Number not rejected!");
                        })
                },
                approveVat: function(vatNumber) {
                    var data = this.packageData({ vat_number_id : vatNumber, approve: true});
                    axios.post('/cs-portal/vat-numbers/update', data)
                        .then(function(response) {
                            if(response.data.success) {
                                sw.notifications.success("VAT Number Approved!");
                            } else {
                                sw.notifications.error("Something went wrong. VAT Number was not approved!");
                            }
                        })
                        .catch(function (error) {
                            sw.notifications.error("Something went wrong. VAT Number not approved!");
                        })

                }
            }
        })
    });
};
